export default __webpack_public_path__ + "static/media/Ellipse2.1fd026b5.svg";